import { useQuery } from '@tanstack/react-query';

import { MAX_KEYWORD_QUERY_LENGTH } from '@website/components/KeywordSuggestionsDropdown';
import { type Suggestion, getSuggestions } from '@website/services/suggestions.service';

export function useSuggestions(query: string, locale: string) {
  const trimmed = query.trim();
  return useQuery<Suggestion[]>({
    queryKey: ['suggestions', locale, trimmed],
    queryFn: () => getSuggestions(trimmed, locale),
    // Out-of-bounds queries would be guaranteed 400s — don't send them.
    enabled: trimmed.length >= 1 && trimmed.length <= MAX_KEYWORD_QUERY_LENGTH,
    staleTime: 60 * 1000,
    placeholderData: (prev) => prev
  });
}
